const doc = [({"openstack":["sponsored-projects"], "fntech":["room-bookings", "room-booking"]})];
module.exports = doc.length <= 1 ? doc[0] : doc;